// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/utils/formDiff.js
//
// Diff générique entre un formulaire contrôlé et son état initial, pour ne
// jamais envoyer aux PUT partiels de cette codebase (legal-identity,
// admin-profile...) un champ non réellement modifié par l'utilisateur.
// `undefined` dans le payload = champ inchangé côté serveur : seuls les
// champs réellement édités doivent partir dans la requête, jamais une
// valeur "par défaut" pour un champ non touché.
//
// Renommé depuis legalIdentityFormDiff.js (2026-09-15) en l'ouvrant à un 2e
// usage (admin-profile) — la fonction était déjà générique, seul le nom du
// fichier ne l'était pas. Extrait à l'origine pour rester testable sans
// monter de composant (pas de jsdom dans ce runner — cf.
// project_frontend_no_test_runner).
export function toUpdatePayload(form, initial) {
  const payload = {}
  for (const key of Object.keys(form)) {
    if (form[key] !== initial[key]) payload[key] = form[key]
  }
  return payload
}
